export default __webpack_public_path__ + "static/media/III-2022.9d9157d0.pdf";